/**
 * Drives the grey "scroll progress" bar shown on mobile in place of the
 * prev/next arrows for the product media gallery slider.
 *
 * Deliberately kept as its own small asset file (rather than appended to
 * t-product.js) because the Shopify theme write API used for this project
 * rejects payloads over ~29.5KB, and t-product.js is already close to that
 * ceiling.
 */
(function () {
  function initSliderProgress(root) {
    if (root.dataset.progressBound === 'true') return;

    var slider = root.querySelector('[id^="Slider-Gallery-"]');
    var thumb = root.querySelector('.slider-progress__thumb');
    if (!slider || !thumb) return;

    root.dataset.progressBound = 'true';

    function render() {
      var clientWidth = slider.clientWidth;
      var scrollWidth = slider.scrollWidth;
      var scrollLeft = slider.scrollLeft;
      var maxScroll = scrollWidth - clientWidth;

      var thumbWidth = 100;
      var thumbShift = 0;

      if (scrollWidth > clientWidth) {
        thumbWidth = (clientWidth / scrollWidth) * 100;
        thumbShift = maxScroll > 0 ? (scrollLeft / maxScroll) * (100 - thumbWidth) : 0;
      }

      root.style.setProperty('--sliderThumbWidth', thumbWidth + '%');
      root.style.setProperty('--sliderThumbShift', thumbShift + '%');
    }

    slider.addEventListener('scroll', render, { passive: true });
    window.addEventListener('resize', render);
    render();
  }

  function initAll() {
    document.querySelectorAll('.product-page slider-component').forEach(initSliderProgress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-bind after a variant swap re-renders the product-info markup
  document.addEventListener('product-info:loaded', initAll);
})();
